import LoadingOverlay from "@/components/LoadingOverlay";
import { DisclosureHost } from "@/hooks/use-disclosure";
import LegacyEncounterSummaryDrawer from "@/pages/app/provider/billings/encounter/LegacyEncounterSummaryDrawer";
import { INITIAL_F2F_FORM_TYPES } from "@/pages/app/provider/patient/patient-list/patient-chart-new/patient-visit-note/encounter/note-forms/initial-f2f";
import { EncounterSumaryFormTypeEnum } from "@/services";
import { useNoteFormType } from "./hooks/use-note-form-type";
import NotePreviewModal from "./NotePreviewModal";

export interface SignedNoteSummaryProps {
  /** Opened with the appointment id: `disclosure.open(appointmentId)`. */
  disclosure: DisclosureHost;
  onClose?: () => void;
  /** Skips the lookup when the caller already knows the note's form type. */
  formType?: EncounterSumaryFormTypeEnum;
}

/** Premier MD notes open the report preview with section selection; every other note opens the generated PDF. */
const SignedNoteSummary = ({
  disclosure,
  onClose,
  formType: knownFormType,
}: SignedNoteSummaryProps) => {
  const appointmentId: string | undefined = disclosure.data;
  const { formType, isResolving } = useNoteFormType(
    appointmentId,
    knownFormType,
    disclosure.opened
  );

  if (!disclosure.opened) return null;
  if (isResolving) return <LoadingOverlay isLoading />;

  return formType && INITIAL_F2F_FORM_TYPES.includes(formType) ? (
    <NotePreviewModal disclosure={disclosure} onClose={onClose} />
  ) : (
    <LegacyEncounterSummaryDrawer disclosure={disclosure} onClose={onClose} />
  );
};

export default SignedNoteSummary;
